module.exports = __webpack_public_path__ + "static/media/REGULAR.2c2ea3ee.svg";